import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Icon from '@material-ui/core/Icon';
import Input from '@material-ui/core/Input';
import Link from '@material-ui/core/Link';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import { WithStyles, withStyles, withTheme } from '@material-ui/core/styles';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link as RouterLink, match } from 'react-router-dom';
import { AddIcon } from '../../../assets/images';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// Components
import { ActionLogs } from '../../../components/action-logs';
import { Anchor } from '../../../components/anchor';
import { AnchorBlock } from '../../../components/anchorBlock';
import App from '../../../components/app';
import { ActionCustom, FormatType, ListCell } from '../../../local-types';
import { Dialog } from '../../../components/dialog';
import ErrorMessage from '../../../components/error-message';
import EnhancedListItem from '../../../components/listItem';
import { Logo } from '../../../components/menu-drawer/menu-drawer';
import { TooltipButton } from '../../../components/tooltip-button';
import { Typobold } from '../../../components/typobold';
import Listing from '../../../components/listing';
import { InlineDocument } from '../../../components/inlineDocument';
// Modules
import {
    BillPartner,
    PartnerBillArrayById,
    Driver,
    DriverArrayById,
    Manager,
    ManagerArrayById,
    Partner,
    PartnerById,
    Vehicle,
    VehicleArrayById,
    Rule,
    LightStructure,
    DocumentType,
    Ride,
    TParams,
    DocumentMode,
} from '../../../redux/reducers/api-types';
import { selectors as documentSelectors } from '../../../redux/reducers/documents';
import { actions as errorActions, ErrorPayload, selectors as errorSelectors } from '../../../redux/reducers/errors';
import {
    actions as partnerActions,
    selectors as partnerSelectors,
    types as partnerTypes,
} from '../../../redux/reducers/partners';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
// Ressources
import AddressUtils from '../../../utils/addressUtils';
import DateUtils from '../../../utils/dateUtils';
import FormattingUtils from '../../../utils/formattingUtils';
import withGlobalStyles from '../../../utils/global-styles';
import UserUtils, { AccountRight, RightRank } from '../../../utils/userUtils';
import styles from './partner-view-style';
import { createPath, paths } from '../../paths';
import StringUtils from '../../../utils/stringUtils';
import { getBanReason, getVehicleModel } from '../../../utils/businessUtils';
import { clsx } from '../../../utils/htmlUtils';
import MainLoading from '../../../components/main-loading';

interface PartnerViewProps extends WithTranslation, WithStyles {
    theme: any;
    globalClasses: any;
    match: match<TParams>;
    partners: PartnerById;
    documents: any; //TODO
    drivers: DriverArrayById;
    vehicles: VehicleArrayById;
    managers: ManagerArrayById;
    partnersBillsLog: PartnerBillArrayById;
    paymentRules: Rule[];
    getPartnerError: ErrorPayload;
    clearError: (errorType: string) => void;
    getGenerationPartnershipContractError: ErrorPayload;
    setPartnerPaymentRuleError: ErrorPayload;
    saveAdjustmentError: ErrorPayload;
    isCreatingPartnerContract: boolean;
    getPartner: (id: string) => void;
    getPartnerDrivers: (id: string) => void;
    getPartnerVehicles: (id: string) => void;
    getPartnerManagers: (id: string) => void;
    getPartnerBills: (id: string) => void;
    saveAdjustment: (payload: any) => void;
    regeneratePartnershipContract: (idPartner: number, managerId: number) => void;
    getPaymentRules: () => void;
    setPartnerPaymentRule: (id: string, payload: any) => void;
}

interface PartnerViewState {
    formData: any;
    hidden: { managers?: boolean; drivers?: boolean; vehicles?: boolean };
}

class PartnerViewPage extends React.Component<PartnerViewProps, PartnerViewState> {
    isPartnerBillingRead: boolean = UserUtils.checkRights({
        name: AccountRight.PARTNER_BILLING,
        mode: RightRank.R,
    });
    isPartnerBilling: boolean = UserUtils.checkRights({
        name: AccountRight.PARTNER_BILLING,
        mode: RightRank.W,
    });
    canWriteSettings: boolean = UserUtils.checkRights({
        name: AccountRight.PARTNER_SETTINGS,
        mode: RightRank.W,
    });

    state = {
        formData: { rule_id: {} },
        hidden: {} as { managers?: boolean; drivers?: boolean; vehicles?: boolean },
    };

    componentDidMount() {
        this.load();
    }

    load = (): void => {
        // A failure recorded for the entity we come from would otherwise greet the next
        // one with the retry panel instead of the loader.
        this.props.clearError(partnerTypes.GET_PARTNER);

        const {
            match,
            getPartner,
            getPartnerDrivers,
            getPartnerVehicles,
            getPartnerManagers,
            getPartnerBills,
            // getPaymentRules,
        } = this.props;
        const id = match.params.id;

        getPartner(id);
        getPartnerDrivers(id);
        getPartnerVehicles(id);
        getPartnerManagers(id);
        if (this.isPartnerBillingRead || this.isPartnerBilling) {
            getPartnerBills(id);
        }
        // getPaymentRules();
    };

    //========================================//
    //=============== Handlers ===============//
    //========================================//

    handleAction(partner: Partner, fields) {
        const payload = {
            label: fields.description,
            partner_id: partner.uuid,
            pre_tax_partner: Number(fields.amount),
            product_type: 'adjustment_transport',
        };
        // console.log(payload);
        this.props.saveAdjustment(payload);
    }

    handlePartnershipContract(partner: Partner, fields) {
        this.props.regeneratePartnershipContract(partner.id, fields.manager_id);
    }

    handleSubmit(event, rule) {
        event.preventDefault();
        const { rule_id } = this.state.formData;
        const id = this.props.match.params.id;
        this.props.setPartnerPaymentRule(id, {
            rules: [{ rule, rule_id, date: -1 }],
        });
    }

    //========================================//
    //=============== Builders ===============//
    //========================================//

    generateListItems = (partnerPayload: Partner, managersPayload: Manager[]): ListCell[] => {
        const { t } = this.props;

        if (!partnerPayload) {
            return [];
        }
        if (!this.canWriteSettings) {
            return [{ title: t('common:form.id'), data: partnerPayload.id, readOnly: true }];
        }
        const listItems: ListCell[] = [
            { title: t('common:form.id'), data: partnerPayload.id, readOnly: true },
            { title: t('partner_type'), data: t(partnerPayload.company_type) },
            {
                title: t('share_capital'),
                data: partnerPayload.share_capital,
                type: FormatType.Price,
            },
            {
                title: t('siret'),
                data: partnerPayload.siret && (
                    <Link
                        color="secondary"
                        href={`https://www.societe.com/cgi-bin/search?champs=${partnerPayload.siret}`}
                    >
                        {partnerPayload.siret}
                    </Link>
                ),
            },
            { title: t('iban'), data: partnerPayload.bank_iban },
            { title: t('bic'), data: partnerPayload.bank_bic },
            { title: t('vat_number'), data: partnerPayload.vat_number },
            { title: t('rcs'), data: partnerPayload.rcs },
            {
                title: t('vtc_number'),
                data: partnerPayload.licence_number_atout_france,
            },
            {
                title: t('billing_address'),
                data: partnerPayload.billing_address && AddressUtils.objectToAddress(partnerPayload.billing_address),
            },
            // {
            //     title: t('billing'),
            //     data: `${partnerPayload.billing_period?.months} ${t('billing_components.month')} ${
            //         partnerPayload.billing_period?.weeks
            //     } ${t('billing_components.week')} ${partnerPayload.billing_period?.days} ${t(
            //         'billing_components.day',
            //     )}`,
            // },
            // { title: t('paymentRules'), data: paymentRules.length > 0 && partnerPayload.active_payment_rule_association?.rule?.id && paymentRules.find(r => r.id === partnerPayload.active_payment_rule_association.rule.id).description },
            {
                title: t('snappay'),
                data:
                    partnerPayload.express_payment_status &&
                    t(`snappay_status.${partnerPayload.express_payment_status}`),
            },
            {
                title: t('common:form.additional_infos'),
                data: partnerPayload.additional_info,
                optional: true,
            },
        ];
        return listItems;
    };

    generateDocuments = (partnerPayload: Partner): DocumentType[] => {
        const { t } = this.props;
        if (!partnerPayload) {
            return [];
        }

        const documents: DocumentType[] = [
            {
                id: partnerPayload.documents.contract,
                name: t('common:docs.contract'),
                docType: 'contract',
                mode: DocumentMode.YOUSIGN,
            },
            {
                id: partnerPayload.documents.kbis,
                name: t('common:docs.kbis'),
                docType: 'kbis',
                endDate: true,
            },
            {
                id: partnerPayload.documents.rm,
                name: t('common:docs.rm'),
                docType: 'rm',
            },
            {
                id: partnerPayload.documents.rib,
                name: t('common:docs.rib'),
                docType: 'rib',
            },
            {
                id: partnerPayload.documents.rc_pro,
                name: t('common:docs.rc_pro'),
                docType: 'rc_pro',
                endDate: true,
            },
            {
                id: partnerPayload.documents.vtc_license,
                name: t('common:docs.vtc_license'),
                docType: 'vtc_license',
                endDate: true,
            },
            {
                id: partnerPayload.documents.urssaf_attestation,
                name: t('common:docs.urssaf_attestation'),
                docType: 'urssaf_attestation',
            },
        ];
        return documents;
    };

    generateListDocuments = (partnerPayload: Partner, managersPayload: Manager[]): ListCell[] => {
        const { t, documents: docs } = this.props;
        const documents = this.generateDocuments(partnerPayload);

        const cells: ListCell[] = documents.map((doc) => {
            return {
                title: t(`common:docs.${doc.docType}`),
                data: true,
                customValue: (
                    <InlineDocument
                        {...doc}
                        docClass="partner"
                        classId={partnerPayload.id}
                        noLabel={true}
                        readOnly={!this.canWriteSettings}
                        datas={managersPayload ? managersPayload : []}
                    />
                ),
            };
        });

        cells.splice(5, 0, {
            title: t('rc_pro_expiration'),
            data: partnerPayload.documents?.rc_pro && docs[partnerPayload.documents.rc_pro]?.current_version?.end_date,
            type: FormatType.DateShort,
        });

        cells.splice(7, 0, {
            title: t('vtc_expiration'),
            data:
                partnerPayload.documents?.vtc_license &&
                docs[partnerPayload.documents.vtc_license]?.current_version?.end_date,
            type: FormatType.DateShort,
        });

        return cells;
    };

    generateActions = (partnerPayload: Partner, managersPayload: Manager[]): ActionCustom[] => {
        const { t, classes, documents: docs } = this.props;
        if (!partnerPayload) {
            return [];
        }

        const actions: ActionCustom[] = [];
        if (this.isPartnerBilling) {
            actions.push({
                label: t('booking:refound.btnIncome'),
                customView: (
                    <Dialog
                        btnTitle={t('booking:refound.title')}
                        description={t('booking:refound.description')}
                        customButton={<div>{t('booking:refound.btnIncome')}</div>}
                        formComponent={
                            <>
                                <FormControl key={'formReason'} style={{ display: 'flex' }}>
                                    <div>{t('booking:refound.reason')}</div>
                                    <Input
                                        type="text"
                                        name={'description'}
                                        className={classes.formInput}
                                        required={true}
                                        inputProps={{ list: 'reasons' }}
                                    />
                                    <datalist id={'reasons'}>
                                        <option value={t('booking:refound.optionsReason.a') as any} />
                                        <option value={t('booking:refound.optionsReason.b') as any} />
                                        <option value={t('booking:refound.optionsReason.c') as any} />
                                        <option value={t('booking:refound.optionsReason.d') as any} />
                                        <option value={t('booking:refound.optionsReason.e') as any} />
                                    </datalist>
                                </FormControl>
                                <br />
                                <FormControl key={'formAmount'}>
                                    <div>{t('booking:refound.adjustment')}</div>
                                    <Input
                                        type="number"
                                        name={'amount'}
                                        className={classes.formInput}
                                        required={true}
                                        inputProps={{ step: 0.01 }}
                                    />
                                    <br />
                                    <div>{t('booking:refound.amount_hint')}</div>
                                </FormControl>
                            </>
                        }
                        onOK={(fields) => this.handleAction(partnerPayload, fields)}
                    />
                ),
            });
        }
        if (partnerPayload && managersPayload?.length > 0) {
            actions.push({
                label:
                    !partnerPayload.documents || (partnerPayload.documents && !partnerPayload.documents.contract)
                        ? t('partnership_contract.title')
                        : t('partnership_contract.regenerate'),
                customView: (
                    <Dialog
                        btnTitle={t('partnership_contract.title')}
                        description={t('partnership_contract.description')}
                        customButton={<div>{t('partnership_contract.description')}</div>}
                        formComponent={
                            <FormControl key={'formManagers'} style={{ display: 'flex' }}>
                                <div>{t('partnership_contract.label')}</div>
                                <Select native name={'manager_id'} className={classes.formInput} required={true}>
                                    {managersPayload.map((m, index) => {
                                        return (
                                            <option key={index} value={m.id}>
                                                {m.fullname}
                                            </option>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        }
                        onOK={(fields) => this.handlePartnershipContract(partnerPayload, fields)}
                    />
                ),
            });
        }

        return actions;
    };

    renderPaymentRules = (partnerPayload: Partner, optionsPaymentRules: LightStructure[]) => {
        const { formData } = this.state;
        const { t, classes } = this.props;
        return (
            this.canWriteSettings &&
            optionsPaymentRules.length > 0 && (
                <form onSubmit={(e) => this.handleSubmit(e, partnerPayload.active_payment_rule_association.rule)}>
                    <Anchor id="paymentRules" />
                    <Typobold>{t('paymentRules')}</Typobold>
                    <Card className={clsx(classes.card, classes.partnerInfo)}>
                        <CardContent>
                            <List>
                                <ListItem>
                                    <FormLabel className={classes.partnerInfoLabel} style={{ marginRight: 8 }}>
                                        {t('paymentRules')}
                                    </FormLabel>
                                    <FormControl margin="dense">
                                        <Select
                                            native
                                            id={'rule_id'}
                                            name={'rule_id'}
                                            defaultValue={partnerPayload.active_payment_rule_association.rule.id}
                                            required={true}
                                            onChange={(event) => {
                                                formData.rule_id = parseInt(event.target.value as string);
                                                this.setState({
                                                    formData,
                                                });
                                            }}
                                        >
                                            {optionsPaymentRules.map((select, i) => {
                                                return (
                                                    <option key={select.id} value={select.id}>
                                                        {select.name}
                                                    </option>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </ListItem>
                            </List>
                        </CardContent>
                        <CardActions className={classes.rightActions}>
                            <Button
                                type="submit"
                                variant="contained"
                                color={
                                    partnerPayload.active_payment_rule_association.rule.id === formData.rule_id
                                        ? 'inherit'
                                        : 'secondary'
                                }
                            >
                                {t('common:validate')}
                            </Button>
                        </CardActions>
                    </Card>
                </form>
            )
        );
    };

    renderManagers = (managersPayload: Manager[]) => {
        const { t, globalClasses, classes, theme, match } = this.props;
        const { hidden } = this.state;
        const filtreActivated = hidden.managers;
        const id = match.params.id;
        return (
            managersPayload && (
                <div className={classes.driversCtn}>
                    {managersPayload
                        .filter((driver) => (filtreActivated ? !driver.banned : true))
                        .sort((a, b) => a.lastname.localeCompare(b.lastname))
                        .map((driver) => {
                            return (
                                <Card
                                    className={clsx(classes.card, classes.driverInfo)}
                                    style={{
                                        backgroundColor: driver.banned ? theme.palette.danger.contrastText : 'white',
                                    }}
                                    key={driver.id}
                                >
                                    <CardContent>
                                        <Typography variant="h6" component="h3">
                                            {StringUtils.userFullname(driver)}
                                        </Typography>
                                        {/* {driver.banned && <Typography variant="body1" component="div" color="error">
                                            {t('common:suspended')}
                                        </Typography>} */}
                                        <Typography variant="body2" color="textSecondary">
                                            {`${t('common:form.id')} #${driver.id}`}
                                        </Typography>
                                        <Typography variant="body1" component="div" gutterBottom={true}>
                                            <div className={globalClasses.centerVertical}>
                                                <Icon fontSize="small">email</Icon> {driver.email}
                                            </div>
                                            <div className={globalClasses.centerVertical}>
                                                <Icon fontSize="small">phone</Icon> {driver.phone_number}
                                            </div>
                                        </Typography>
                                    </CardContent>
                                    <CardActions>
                                        <Button
                                            component={RouterLink}
                                            to={createPath(paths.partnersManagersDetails, { id, idm: driver.id })}
                                            color="primary"
                                        >
                                            {t('manager_page')}
                                        </Button>
                                    </CardActions>
                                </Card>
                            );
                        })}
                </div>
            )
        );
    };

    renderDrivers = (driversPayload: Driver[]) => {
        const { t, globalClasses, classes, theme } = this.props;
        const { hidden } = this.state;
        const filtreActivated = hidden.drivers;
        return (
            driversPayload && (
                <div className={classes.driversCtn}>
                    {driversPayload
                        .filter((driver) => (filtreActivated ? !driver.banned : true))
                        .sort((a, b) => a.lastname.localeCompare(b.lastname))
                        .map((driver) => {
                            const banReason = driver.banned ? getBanReason(t, driver) : '';
                            return (
                                <TooltipButton title={banReason} key={driver.id}>
                                    <Card
                                        className={clsx(classes.card, classes.driverInfo)}
                                        style={{
                                            backgroundColor: driver.banned
                                                ? theme.palette.danger.contrastText
                                                : 'white',
                                        }}
                                    >
                                        <CardContent>
                                            <Typography variant="h6" component="h3">
                                                {StringUtils.userFullname(driver)}
                                            </Typography>
                                            {/* {driver.banned && <Typography variant="body1" component="div" color="error">
                                                {t('common:suspended')}
                                            </Typography>} */}
                                            <Typography variant="body2" color="textSecondary">
                                                {`${t('common:form.id')} #${driver.id}`}
                                                {/* {driver.banned && `- ${banReason}`} */}
                                            </Typography>
                                            <Typography variant="body1" component="div" gutterBottom={true}>
                                                <div
                                                    className={globalClasses.centerVertical}
                                                    style={{ flexWrap: 'wrap' }}
                                                >
                                                    <Icon fontSize="small">email</Icon> {driver.email}
                                                </div>
                                                <div className={globalClasses.centerVertical}>
                                                    <Icon fontSize="small">phone</Icon> {driver.phone_number}
                                                </div>
                                            </Typography>
                                            <Typography variant="body1" component="div">
                                                <Typography color="textSecondary" component="span">
                                                    {t('accepted_services')}
                                                </Typography>{' '}
                                                {driver.dispatch_groups.map((dg: { name: any }) => dg.name).join(', ')}
                                            </Typography>
                                        </CardContent>
                                        <CardActions>
                                            <Button
                                                component={RouterLink}
                                                to={`${paths.drivers}/${driver.id}`}
                                                color="primary"
                                            >
                                                {t('driver_page')}
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </TooltipButton>
                            );
                        })}
                </div>
            )
        );
    };

    renderVehicles = (vehiclesPayload: Vehicle[]) => {
        const { t, globalClasses, classes, theme } = this.props;
        const { hidden } = this.state;
        const filtreActivated = hidden.vehicles;
        return (
            vehiclesPayload && (
                <div className={classes.vehiclesCtn}>
                    {vehiclesPayload
                        .filter((vehicle) => (filtreActivated ? !vehicle.deletion_date : true))
                        .map((vehicle) => {
                            return (
                                <Card
                                    className={clsx(classes.card, classes.vehicleInfo)}
                                    style={{
                                        backgroundColor: vehicle.deletion_date
                                            ? theme.palette.danger.contrastText
                                            : 'white',
                                    }}
                                    key={vehicle.id}
                                >
                                    <CardContent>
                                        <Typography variant="h6" component="h3">
                                            {getVehicleModel(vehicle)}
                                        </Typography>
                                        {/* {vehicle.deletion_date && <Typography variant="body1" component="div" color="error">
                                            {t('common:inactive')}
                                        </Typography>} */}
                                        <Typography variant="body2" color="textSecondary">
                                            {`${t('common:form.id')} #${vehicle.id}`}
                                        </Typography>
                                        <Typography variant="body1" component="div" gutterBottom={true}>
                                            <div className={globalClasses.centerVertical}>
                                                <Icon fontSize="small">credit_card</Icon> {vehicle.registration_number}
                                            </div>
                                            <div className={globalClasses.centerVertical}>
                                                <Icon fontSize="small">color_lens</Icon> 
                                                {(vehicle.vehicle_color || { name: vehicle.color }).name}
                                            </div>
                                        </Typography>
                                    </CardContent>
                                    <CardActions>
                                        <Button
                                            component={RouterLink}
                                            to={`${paths.vehicles}/${vehicle.id}`}
                                            color="primary"
                                        >
                                            {t('vehicle_page')}
                                        </Button>
                                    </CardActions>
                                </Card>
                            );
                        })}
                </div>
            )
        );
    };

    renderBillsLog = (billsLogPayload: BillPartner[]) => {
        const { t, globalClasses, classes } = this.props;
        return (
            <AnchorBlock
                id="bills_log"
                title={t('bills_log')}
                items={
                    this.canWriteSettings &&
                    billsLogPayload &&
                    billsLogPayload.length > 0 && (
                        <>
                            <div className={classes.driversCtn}>
                                {/* TODO: check and link with new billing */}
                                {billsLogPayload.map((billLog) => {
                                    return (
                                        <Card className={clsx(classes.card, classes.driverInfo)} key={billLog.id}>
                                            <CardContent>
                                                <Typography variant="h6" component="h3">
                                                    {`${billLog.amount_pre_tax} € HT (${billLog.amount_with_tax} € TTC)`}
                                                </Typography>
                                                <Typography variant="body1" component="div">
                                                    {t('partner_bill:partner_bill_status.' + billLog.status)}
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    {`${t('common:form.id')} #${billLog.id}`}
                                                </Typography>
                                                <Typography variant="body1" component="div" gutterBottom={true}>
                                                    <div className={globalClasses.centerVertical}>
                                                        <Icon fontSize="small">event_available</Icon>
                                                        {DateUtils.tsToDate(
                                                            new Date(billLog.start_date).getTime() / 1000,
                                                            true,
                                                        )}
                                                    </div>
                                                    <div className={globalClasses.centerVertical}>
                                                        <Icon fontSize="small">event_busy</Icon>
                                                        {DateUtils.tsToDate(
                                                            new Date(billLog.end_date).getTime() / 1000,
                                                            true,
                                                        )}
                                                    </div>
                                                </Typography>
                                            </CardContent>
                                            <CardActions>
                                                <Button
                                                    component={RouterLink}
                                                    to={`${paths.billsPartner}/${billLog.id}`}
                                                    color="primary"
                                                >
                                                    {t('bill_log_page')}
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    );
                                })}
                            </div>
                        </>
                    )
                }
            />
        );
    };

    renderCourseDetails = (course: Ride) => {
        const { t } = this.props;
        return (
            <div key={course.ride_number} style={{ display: 'flex' }}>
                <Link color="secondary" component={RouterLink} to={`${paths.bookings}/${course.ride_id}`}>
                    {t('booking:booking.number', { id: course.ride_id })} -{' '}
                    {DateUtils.tsToDate(new Date(course.start_date).getTime() / 1000)}
                </Link>
                <div style={{ flex: 1, textAlign: 'end' }}>{`${FormattingUtils.price(
                    course.pre_tax_partner,
                    true,
                )} HT`}</div>
            </div>
        );
    };

    renderCurrentPeriodRidesDetails = (partnerPayload: Partner) => {
        const { t } = this.props;

        const ridesByDriver = partnerPayload.current_period.rides.reduce((acc, ride) => {
            const driverInfos = acc[ride.driver.id]?.rides || [];
            return {
                ...acc,
                [ride.driver.id]: {
                    driver: ride.driver.name,
                    rides: [...driverInfos, ride],
                    total: (acc[ride.driver.id]?.total || 0) + ride.pre_tax_partner,
                },
            };
        }, {});

        const ridesByDriverKeys = Object.keys(ridesByDriver);

        if (ridesByDriverKeys.length <= 0) {
            return <div>{t('current_period.ride_none')}</div>;
        }

        return ridesByDriverKeys.map((driverKey) => {
            const infos = ridesByDriver[driverKey];
            return (
                <Accordion key={driverKey}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel-${driverKey}`}
                        id={`panel-${driverKey}`}
                    >
                        <Link color="secondary" component={RouterLink} to={`${paths.drivers}/${driverKey}`}>
                            {infos.driver}
                        </Link>
                        <div style={{ flex: 1, textAlign: 'end' }}>{`${FormattingUtils.price(
                            infos.total,
                            true,
                        )} HT`}</div>
                    </AccordionSummary>
                    <AccordionDetails style={{ flexDirection: 'column' }}>
                        {infos.rides?.map((course) => this.renderCourseDetails(course))}
                    </AccordionDetails>
                </Accordion>
            );
        });
    };

    renderCurrentPeriodRegulationDetails = (partnerPayload: Partner) => {
        const { t } = this.props;
        return (
            <Listing
                datas={partnerPayload.current_period.adjustments?.map((item, key) => (
                    <div key={key}>
                        <div>
                            {DateUtils.stringToDate(item.created_at)} - {item.author ? `${item.author.name} - ` : ''}
                            {item.label}
                        </div>
                        {item.with_tax_customer !== 0 && <div>Client : {item.with_tax_customer} € (TTC)</div>}
                        {item.with_tax_partner !== 0 && (
                            <div>
                                {item.partner?.name || 'Partenaire'} : {item.with_tax_partner} € (TTC)
                            </div>
                        )}
                        <div>{t(`booking:regulation_type.${item.product_type}`)}</div>
                        {item.ride_id ? (
                            <Link color="secondary" component={RouterLink} to={`${paths.bookings}/${item.ride_id}`}>
                                {t('booking:booking.number', { id: item.ride_id })}
                            </Link>
                        ) : (
                            <div>{t('booking:booking.none')}</div>
                        )}
                    </div>
                ))}
                customEmpty={t('current_period.regulation_none')}
            />
        );
    };

    renderHide = (mode: string): JSX.Element => {
        const { t } = this.props;
        const { hidden } = this.state;
        const isHidden = hidden[mode];
        return (
            <TooltipButton title={t(isHidden ? 'common:show' : 'common:hide', { detail: t('disabled_item') })}>
                <Button
                    onClick={() => {
                        const tmp = { ...hidden };
                        tmp[mode] = !tmp[mode];
                        this.setState({
                            hidden: tmp,
                        });
                    }}
                    style={{ textTransform: 'none' }}
                >
                    <Icon fontSize="small" style={{ marginRight: 4 }}>
                        {isHidden ? 'visibility_off' : 'visibility'}
                    </Icon>
                    {t(isHidden ? 'common:show' : 'common:hide')} {t('disabled_item')}
                </Button>
            </TooltipButton>
        );
    };

    render() {
        const {
            t,
            classes,
            match,
            partners,
            drivers,
            vehicles,
            managers,
            partnersBillsLog,
            // paymentRules,
            getPartnerError,
            getGenerationPartnershipContractError,
            isCreatingPartnerContract,
        } = this.props;
        const id: string = match.params.id;

        const partnerPayload = partners[id];
        const driversPayload = drivers[id];
        const vehiclesPayload = vehicles[id];
        const managersPayload = managers[id];
        const billsLogPayload = partnersBillsLog[id];

        // const paymentRulesArray = paymentRules || [];
        // let optionsPaymentRules: LightStructure[] = [];

        // if (paymentRulesArray?.length === 0) {
        //     paymentRulesArray.forEach((p) => {
        //         optionsPaymentRules.push({ id: p.id, name: p.description });
        //     });
        // }

        return (
            <App
                needRights={{ name: AccountRight.PARTNER_SETTINGS, mode: RightRank.R }}
                loading={!partnerPayload}
                loadingError={this.props.getPartnerError}
                onRetry={this.load}
                header={{
                    icon: 'default',
                    title: partnerPayload?.name,
                    subtitle: partnerPayload && `ID: ${partnerPayload.id}`,
                    bubble: {
                        visible: partnerPayload?.banned,
                        text: t('common:suspended'),
                    },
                    actions: this.generateActions(partnerPayload, managersPayload),
                    anchors: [
                        { href: '#general_infos', label: t('common:form.general_infos') },
                        // { href: '#paymentRules', label: t('paymentRules') },
                        { href: '#documents', label: t('common:form.documents') },
                        { href: '#managers', label: t('managers') },
                        { href: '#drivers', label: t('drivers') },
                        { href: '#vehicles', label: t('vehicles') },
                        { href: '#bills_log', label: t('bills_log') },
                        { href: '#history', label: t('common:history') },
                    ],
                }}
            >
                <ErrorMessage payload={getPartnerError} />
                <ErrorMessage payload={getGenerationPartnershipContractError} />
                <ErrorMessage payload={this.props.setPartnerPaymentRuleError} />
                <ErrorMessage payload={this.props.saveAdjustmentError} />
                {isCreatingPartnerContract && <MainLoading center message={t('common:generating')} />}
                {partnerPayload && (
                    <>
                        <br />
                        <Anchor id="general_infos" />
                        <EnhancedListItem
                            datas={this.generateListItems(partnerPayload, managersPayload)}
                            title={t('common:form.general_infos')}
                            cardActions={
                                this.canWriteSettings && (
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        component={RouterLink}
                                        to={createPath(paths.partnersEdit, { id })}
                                    >
                                        {t('common:edit')}
                                    </Button>
                                )
                            }
                        />
                        <br />
                        {/* {this.renderPaymentRules(partnerPayload, optionsPaymentRules)} */}
                        <Anchor id="documents" />
                        {this.canWriteSettings && (
                            <EnhancedListItem
                                datas={this.generateListDocuments(partnerPayload, managersPayload)}
                                title={t('common:form.documents')}
                            />
                        )}
                        <br />
                        <Anchor id="managers" />
                        <div className={classes.itemsHideTitle}>
                            <Typobold>{t('managers')}</Typobold>
                            {this.renderHide('managers')}
                        </div>
                        {this.canWriteSettings && (
                            <Button component={RouterLink} to={createPath(paths.partnersManagersAdd, { id })}>
                                {Logo(AddIcon, {}, 30)}
                                <p className={classes.bold}>{t('add_manager.title')}</p>
                            </Button>
                        )}
                        {this.renderManagers(managersPayload)}
                        <br />
                        <Anchor id="drivers" />
                        <div className={classes.itemsHideTitle}>
                            <Typobold>{t('drivers')}</Typobold>
                            {this.renderHide('drivers')}
                        </div>
                        {this.canWriteSettings && (
                            <Button component={RouterLink} to={createPath(paths.partnersDriversAdd, { id })}>
                                {Logo(AddIcon, {}, 30)}
                                <p className={classes.bold}>{t('add_driver.title')}</p>
                            </Button>
                        )}
                        {this.renderDrivers(driversPayload)}
                        <br />
                        <Anchor id="vehicles" />
                        <div className={classes.itemsHideTitle}>
                            <Typobold>{t('vehicles')}</Typobold>
                            {this.renderHide('vehicles')}
                        </div>
                        {this.canWriteSettings && (
                            <Button component={RouterLink} to={createPath(paths.partnersVehiclesAdd, { id })}>
                                {Logo(AddIcon, {}, 30)}
                                <p className={classes.bold}>{t('add_vehicle.title')}</p>
                            </Button>
                        )}
                        {this.renderVehicles(vehiclesPayload)}
                        <br />

                        {(this.isPartnerBillingRead || this.isPartnerBilling) && (
                            <>
                                <AnchorBlock
                                    id="current_period_rides"
                                    title={t('current_period.driver_title')}
                                    items={this.renderCurrentPeriodRidesDetails(partnerPayload)}
                                />
                                <AnchorBlock
                                    id="current_period_adjustments"
                                    title={t('current_period.regulation_title')}
                                    items={this.renderCurrentPeriodRegulationDetails(partnerPayload)}
                                />

                                {this.renderBillsLog(billsLogPayload)}
                            </>
                        )}
                        <ActionLogs history={partnerPayload.history} withValues />
                    </>
                )}
            </App>
        );
    }
}

const PartnerViewPageWithAllAndTranslation = withGlobalStyles(
    withStyles(styles)(
        withTheme(withTranslation(['partner', 'partner_bill', 'booking', 'document', 'common'])(PartnerViewPage)),
    ),
);

const mapStateToProps = (state) => ({
    partners: partnerSelectors.partners(state),
    documents: documentSelectors.documents(state),
    drivers: partnerSelectors.partnersDrivers(state),
    vehicles: partnerSelectors.partnersVehicles(state),
    managers: partnerSelectors.partnersManagers(state),
    partnersBillsLog: partnerSelectors.partnersBillsLog(state),
    paymentRules: partnerSelectors.paymentRules(state),
    isCreatingPartnerContract: pendingSelectors.isCreatingPartnerContract(state),
    getPartnerError: errorSelectors.getPartnerError(state),
    getGenerationPartnershipContractError: errorSelectors.getGenerationPartnershipContractError(state),
    setPartnerPaymentRuleError: errorSelectors.setPartnerPaymentRuleError(state),
    saveAdjustmentError: errorSelectors.saveAdjustmentError(state),
});

const mapDispatchToProps = {
    clearError: errorActions.clearError,
    getPartner: partnerActions.getPartner,
    getPartnerDrivers: partnerActions.getPartnerDrivers,
    getPartnerVehicles: partnerActions.getPartnerVehicles,
    getPartnerManagers: partnerActions.getPartnerManagers,
    getPartnerBills: partnerActions.getPartnerBills,
    saveAdjustment: partnerActions.saveAdjustment,
    regeneratePartnershipContract: partnerActions.regeneratePartnershipContract,
    getPaymentRules: partnerActions.getPaymentRules,
    setPartnerPaymentRule: partnerActions.setPartnerPaymentRule,
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerViewPageWithAllAndTranslation);
